import React, { useEffect, useState } from "react";
import styled from "styled-components";
import SidebarHeader from "components/Sidebar/layout/SidebarHeader";
import TextButton from "components/TextButton";
import * as Cesium from 'cesium';
import useProjectStore from "../../../../store-zustand/project";
import FormField from "../../../FormField";
import { useDispatch, useSelector } from "react-redux";
import { ArrowBack } from "@mui/icons-material"
import TooltipIconButton from "components/TooltipIconButton";
import ColorPicker from "components/common/ColorPicker";

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
`;
const Title = styled.h2`
  color: white;
`;
const SubTitle = styled.h3`
  font-size: 20px;
  line-height: 23px;
  color: #E5E5E5;
  margin-bottom: 21px;
  padding: 0 0 21px;
  border-bottom: 1px solid #A0A0A0;
`;
const Description = styled.div`
  p {
    color: #C4C4C4;
    &.drag {
      margin-bottom: 15px;
    }
    a {
      text-decoration: underline;
    }
  }
`;


const DownloadItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
  &:hover {
    background-color: #262626;
  }
  span {
    font-family: Roboto;    
    font-weight: 500;
    font-size: 15px;
    line-height: 23px;
    color: #A0A0A0;
    &.selected {
      color: #E5E5E5;
    }
  }
  .actions {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const VirtualTour = ({ types, onClose, selectedType, onBack }) => {
  const { addAssetToProject, project_id, editProjectAsset, reloadAssetList, setreloadAssetList } = useProjectStore();
  const [name, setName] = useState();
  const [link, setLink] = useState();
  const [descriptionValue, setDescription] = useState();
  const selectedIonAsset = useSelector(state => state.asset.selectedIonAsset);
  // const profile = useSelector(state => state.profile.profile);
  const dispatch = useDispatch();

  const handleName = (e) => {
    setName(e.target.value);
  };
  const handleLink = (e) => {
    setLink(e.target.value);
  }

  const handleDescription = (e) => {
    setDescription(e.target.value);
  };

  const removeAllAssets = () => {
    // var iframeElem = document.getElementById("matterport-iframe");
    // iframeElem.src = null;
    // iframeElem.style.display = "none";
    if (!window.assets) return;
    Object.keys(window.assets).map(id => {
      if (window.assets[id]?.type == "3DTILES") {
        window.MAIN_CESIUM_VIEWER.scene.primitives.remove(window.assets[id]);
      } else if (window.assets[id]?.type == "IMAGERY") {
        window.MAIN_CESIUM_VIEWER.imageryLayers.remove(window.assets[id]);
      } else if (window.assets[id]?.type == "TERRAIN") {
        window.MAIN_CESIUM_VIEWER.terrainProvider = Cesium.createWorldTerrainAsync();
      } else if (window.assets[id]?.type == "GLTF") {
        window.MAIN_CESIUM_VIEWER.entities.remove(window.assets[id]);
      } else if (window.assets[id]?.type === "KML" || window.assets[id]?.type === "GEOJSON") {
        window.MAIN_CESIUM_VIEWER.dataSources.remove(window.assets[id]);
      }

      delete (window.assets[id]);
    })
  }

  useEffect(() => {
    removeAllAssets();
    if (selectedIonAsset) {
      setName(selectedIonAsset.name);
      setLink(selectedIonAsset.url)
      setDescription(selectedIonAsset.description);
    }
  }, [])

  const addAsset = () => {
    console.log(selectedIonAsset);
    if (!selectedIonAsset) {
      addAssetToProject(null, "MATTERPORT", null, project_id, name, link, descriptionValue)
        .then(response => {
          console.log(response);
          dispatch({ type: 'SET_PROJECT_PANEL', panel: "Single" });
          setreloadAssetList(!reloadAssetList);
        })
    } else {
      // var selectedAsset = ionAssets.find(item => item.id == selectedIonAsset.assetID);
      editProjectAsset(selectedIonAsset.ID, null, selectedIonAsset.type, !!name ? name : "Untitled", null, link, descriptionValue).then((response) => {
        console.log(response);
        if (response && response !== 500 && response !== 404) {
          dispatch({ type: 'SET_PROJECT_PANEL', panel: "Single" });
          setreloadAssetList(!reloadAssetList);
          // alert("Asset updated");
        } else {
          alert("There was a problem updating asset");
        }
      })
    }
  }


  const handlePickedColor = () => { }
  const handleFeatureWidth = () => { }
  const handlePickedOpacity = () => { }
  const Labelsizevalue = () => { }
  const LabelColorvalue = () => { }
  const handleLabelVisibility = () => { }

  return (
    <>
      <SidebarHeader onClose={onClose}>
        <TooltipIconButton title="Back" ariaLabel="back" placement="bottom" onClick={onBack} size={44}>
          <ArrowBack />
        </TooltipIconButton>
      </SidebarHeader>
      <TitleSection>
        <Title>{`Add Virtual Tour`}</Title>
        <TextButton text="Add Asset"
          onClick={addAsset}
        />
      </TitleSection>
      <FormField label="Tour Name">
        <input
          type="text"
          placeholder="Enter Tour Name"
          value={name}
          onChange={handleName}
        />
      </FormField>
      <FormField label="Matterport Link">
        <input
          type="text"
          placeholder="Enter Matterport Name"
          value={link}
          onChange={handleLink}
        />
      </FormField>
      <FormField label="Description">
        <textarea
          rows="4"
          placeholder="Enter description"
          value={descriptionValue}
          onChange={handleDescription}
        />
      </FormField>
      <ColorPicker
        label="Styling"
        handlePickedColor={handlePickedColor}
        handleFeatureWidth={handleFeatureWidth}
        handlePickedOpacity={handlePickedOpacity}
        Labelsizevalue={Labelsizevalue}
        LabelColorvalue={LabelColorvalue}
        handleLabelVisibility={handleLabelVisibility}
      // type={annotation.type}
      />
      <Description>
        <p className="contact">If you require a 3D SiteScan, you can book a SiteScan with <strong>FastMap Capture</strong>.</p>
      </Description>
    </>
  );
}

export default VirtualTour;